import { Injectable } from '@angular/core';

import { OccCheckoutDeliveryAddressAdapter } from '@spartacus/checkout/base/occ';
import { Observable, of } from 'rxjs';

// TODO: remove disabled eslint rules
@Injectable({
  providedIn: 'root',
})
export class DpOccCheckoutDeliveryAdapter extends OccCheckoutDeliveryAddressAdapter {
  // Overriden in order to remove unnecessary ootb backend calls
  public setAddress(): Observable<unknown> {
    return of({});
  }

  // Overriden in order to use dp custom set method call
  public setMode(): Observable<unknown> {
    // left empty
    return of(null);
  }
}
